<div class="checkbox">
    <mat-checkbox [checked]="isChecked" [disabled]="isDisabled" (change)="checkedHandler($event.checked)">
        @if (isChecked && showLabel) {
        <span class="selected">{{ 'Selected' | translate }}</span>
        }
    </mat-checkbox>
</div>
